import { useQuery } from '@tanstack/react-query';
import { BillingService } from '../services';

/**
 * Hook para buscar planos disponíveis
 */
export const usePlans = () => {
  const {
    data: plans,
    isLoading,
    error,
    refetch,
  } = useQuery({
    queryKey: ['plans'],
    queryFn: ({ signal }) => BillingService.getPlans(signal),
    staleTime: 10 * 60 * 1000, // 10 minutes - plans don't change often
  });

  return {
    plans,
    isLoading,
    error,
    refetch,
  };
};

/**
 * Hook para buscar um plano específico por ID
 */
export const usePlan = (id?: string) => {
  return useQuery({
    queryKey: ['plan', id],
    queryFn: ({ signal }) => BillingService.getPlan(id!, signal),
    enabled: !!id,
    staleTime: 10 * 60 * 1000,
  });
};
